// BASE URL OF SERVER
export const ENV = {
//serverUrl: 'http://127.0.0.1:8000/api/'
   serverUrl: 'https://esim.server18.arhamsoft.info/api/'
  //serverUrl: 'https://www.esimlist.com/server/public/api/'
}
